const CoursesSkeleton = () => {
  return (
    <div className="col-span-12 lg:col-start-3 lg:col-end-11">
      <div className="col-span-12 mt-sh-60 flex justify-center gap-4">
        <div className="h-full w-1/5 animate-pulse  bg-gray-300 py-4"></div>
      </div>

      <div className="col-span-12 mt-5 flex gap-4">
        <div className="h-full w-full animate-pulse  bg-gray-300 py-1"></div>
      </div>
      <div className="col-span-12 flex gap-4">
        <div className="my-2 h-full w-full  animate-pulse bg-gray-300 py-4"></div>
        <div className="my-2 h-full w-full  animate-pulse bg-gray-300 py-4"></div>
        <div className="my-2 h-full w-full  animate-pulse bg-gray-300 py-4"></div>
        <div className="my-2 h-full w-full  animate-pulse bg-gray-300 py-4"></div>
      </div>

      <div className="col-span-12 mb-2 mt-sh-60 flex gap-4">
        <div className="h-full w-[200px] animate-pulse bg-gray-300 py-5"></div>
      </div>

      <div className="col-span-12 flex gap-4">
        <div className="h-full w-[200px] animate-pulse bg-gray-300 py-3"></div>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className="card mb-10 mt-2 grid h-full min-h-[400px] w-full max-w-[414px] animate-pulse cursor-pointer rounded-2xl bg-gray-300" />
        <div className="card mb-10 mt-2 grid h-full min-h-[400px] w-full max-w-[414px] animate-pulse cursor-pointer rounded-2xl bg-gray-300" />
      </div>

      <div className="col-span-12 mb-2 flex gap-4">
        <div className="h-full w-[200px] animate-pulse bg-gray-300 py-5"></div>
      </div>

      <div className="col-span-12 flex gap-4">
        <div className="h-full w-[350px] animate-pulse bg-gray-300 py-3"></div>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className="card mb-10 mt-2 grid h-full min-h-[400px] w-full max-w-[414px] animate-pulse cursor-pointer rounded-2xl bg-gray-300" />
        <div className="card mb-10 mt-2 grid h-full min-h-[400px] w-full max-w-[414px] animate-pulse cursor-pointer rounded-2xl bg-gray-300" />
      </div>
    </div>
  );
};

export default CoursesSkeleton;
